<dokument>
  <ng-container bakgrunn>
    @if (viserInline()) {
      <dokument-inline-pdfviser [dokumentversjon]="dokumentversjon()" medRamme=false (vedLukk)="lukkInlineVising()"/>
    }
    <div class="bakgrunn-kontainer-normal">
      @switch (forsidetype()) {
        @case ('forside') {
          <dokument-forsidebilde [dokumentversjon]="dokumentversjon()"/>
        }
        @case ('ikon') {
          <dokument-format-ikon [mimeinfo]="informasjon().standardformat.mimeinfo" utenDokumentramme="true" stoerrelse="70"/>
        }
        @case ('virussjekk') {
          <!--fått tilbakemelding på at folk tror de må vente på at spinner blir verdig-->
          <dokument-format-ikon [mimeinfo]="informasjon().standardformat.mimeinfo" utenDokumentramme="true" stoerrelse="70"/>
        }
        @case ('infisert') {
          <mat-icon fontSet="ion-alert-circled" class="mat-icon--ionic-ikon infisert"/>
          <div>{{ 'Dokumentet ser ut til å være infisert med virus'|translate }}</div>
        }
      }
    </div>
    <!-- <div ng-switch-when="virussjekk" class="slsd-dokumentforside er-virussjekk_paagaar">
       <md-progress-circular md-diameter="30px" md-mode="indeterminate"></md-progress-circular>
       <div translate>kjører virussjekk</div>
     </div>
     <div ng-switch-when="infisert" class="slsd-dokumentforside er-dokument_infisert">
       <i class='icon ion-alert-circled'></i>
       <div translate>dokumentet ser ut til å være infisert med virus</div>
     </div>-->
  </ng-container>

  @if (elektroniskSigneringAktivert() && signatarinformasjon().skalSignere) {
    <div handling (click.stopp)="signer()" class="signer" data-testid="signer"
         matTooltip="{{'Du har blitt bedt om å signere dette dokumentet, klikk her for å starte signeringsprosessen'}}" matTooltipPosition="after">
      <mat-icon svgIcon="sf:signer"/>
    </div>
  }
  @if (stoetterInlinevisning()) {
    <div handling (click.stopp)="aapneInline()" matTooltip="{{'Åpne opp i forhåndsvisning'|translate}}" matTooltipPosition="after" data-testid="åpne-inline">
      <mat-icon fontSet="ion-ios-eye-outline" class="mat-icon--ionic-ikon"/>
    </div>
  }
  <div handling (click.stopp)="aapneStandardformat()" matTooltip="{{'Åpne opp i ny arkfane'|translate}}" matTooltipPosition="after" data-testid="åpne-standardformat">
    <mat-icon fontSet="lederplan-ikon-aapneiekstern" class="mat-icon--lederplan-ikon"/>
  </div>

  <div filnavn>
    @if (erFavorittmarkert()) {
      <mat-icon>star</mat-icon>
    }
    <span matTooltip="{{'{navn}, registrert {dato} av {bruker}'|translate: {navn: informasjon().standardnavn, dato:dokumentversjon().registreringsdato|zoneddatetimeSomPlaindate|plaindate, bruker: dokumentversjon().registrertAv?.navn} }}" matTooltipPosition="after" data-testid="filnavn">{{ informasjon().standardnavn }}</span>
    @if(dokumentversjon().type == dokumentTyper.protokolldokumentISak && moeteProtokolldokumentISakErProtokollFor() != null){
      <a (click.stopp)="gaaTilProtokoll()" class="protokoll-for-møte" matTooltip="{{'Gå til møte protokollen gjelder for'|translate }}" matTooltipPosition="after">
        {{'Protokoll for møte {nummer}, {dato}'|translate: {nummer: moeteProtokolldokumentISakErProtokollFor()!.nummer, dato: moeteProtokolldokumentISakErProtokollFor()!.dato.start | zoneddatetimeSomPlaindate | plaindate} }}
      </a>
    }
    <!--<dokument-format-ikon [mimeinfo]="informasjon().standardformat.mimeinfo" utenDokumentramme="true"/>-->
  </div>

  <div metainformasjon>
    <!-- <div class="linje">
       <span class="element">
         <dokument-format-ikon [mimeinfo]="informasjon().standardformat.mimeinfo" utenDokumentramme="true"/>
         {{informasjon().standardformat.mimeinfo.visningsnavn}}
       </span>
       <button mat-icon-button [matMenuTriggerFor]="meny" class="mat-small-icon-button">
         <mat-icon>more_vert</mat-icon>
       </button>
       <mat-menu #meny="matMenu">
         <button mat-menu-item>
           <mat-icon>edit</mat-icon>
           <span>{{ "Rediger" | translate }}</span>
         </button>
       </mat-menu>
     </div>-->

    <span class="element" data-testid="antall-versjoner"
          matTooltip="{{'Versjon {versjon}, registrert {dato} av {bruker}'|translate: {versjon:dokumentversjon().versjonsnummer, dato:dokumentversjon().registreringsdato|zoneddatetimeSomPlaindate|plaindate ,bruker:dokumentversjon().registrertAv?.navn} }}">
      <mat-icon inline="true" fontSet="lederplan-ikon-versjoner" class="mat-icon--lederplan-ikon"/>
      {{ dokumentversjon().versjonsnummer }}
    </span>
    <span class="element" data-testid="antall-sider" matTooltip="{{'Antall sider'|translate}}">
      @if (dokumentversjon().antallSider ?? 0 > 0) {
        <mat-icon inline="true" fontSet="lederplan-ikon-aapenbok" class="mat-icon--lederplan-ikon"/>
        {{ dokumentversjon().antallSider }}
      }
    </span>
    <span [class.ingen-annotasjoner]="dokumentversjon().antallAnnotasjoner==0" class="element" data-testid="antall-annotasjoner" matTooltip="{{'Antall annotasjoner'|translate}}">
      @if (dokumentversjon().antallAnnotasjoner > 0) {
        <mat-icon inline="true" fontSet="lederplan-ikon-pencil-marker" class="mat-icon--lederplan-ikon"/>
        {{ dokumentversjon().antallAnnotasjoner }}
      }
    </span>
    <span class="meny-kontainer">
      <button mat-icon-button [matMenuTriggerFor]="meny.matMeny()" (click)="$event.stopPropagation()" class="meny mat-medium-icon-button" data-testid="åpne-meny">
        <mat-icon class="material-symbols-fet">more_vert</mat-icon>
      </button>
    </span>
    <dokument-meny [dokumentversjon]="dokumentversjon()" [signatarinformasjon]="signatarinformasjon()" #meny/>
  </div>
</dokument>

@if (!dokumentversjon().erLestAv && !visNymerkingDeaktivert()) {
  <svg class="ulest" width="60px" height="61px" viewBox="0 0 60 61" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g transform="translate(1.000000, 1.000000)">
      <polygon points="0.160026005 0 58 60 58 30 29.080013 0"></polygon>
      <text transform="translate(38.500000, 21.500000) rotate(45.000000) translate(-38.500000, -21.500000) " font-family="Helvetica" font-size="14" font-weight="normal" fill="#424242">
        <tspan x="31" y="27">{{ 'Ny'|translate }}</tspan>
      </text>
    </g>
  </svg>
}

<div class="tilstandsindikatorer">
  @if(dokumentversjon().skjerming.skjermedeMedlemmerId.length > 0 && !visSkjermingDeaktivert()){
    <mat-icon class="skjermet" (click.stopp)="visSkjerming()" matTooltip="{{'Dokumentet er skjult for {antall} medlemmer, klikk for å se detaljer'| translate: {antall: dokumentversjon().skjerming.skjermedeMedlemmerId.length} }}">visibility_lock</mat-icon>
  }
  @if(elektroniskSigneringAktivert() && !signatarinformasjon().skalSignere){
    <mat-icon fontSet="lederplan-ikon-signer" class="signering-aktivert mat-icon--lederplan-ikon" (click.stopp)="visSignatarer()" [matTooltip]="elektroniskSigneringHjelpetekst()"/>
  }
</div>
